<template>
  <div>
    <BCard>
        <BRow class="">
          <BCol class="d-flex justify-content-between align-items-center">
            <h2>Cuentas contables</h2>
          </BCol>
        </BRow>
        <div >
          <BCardActions
            v-for="(group, index) in accountingGroups"
            :key="index"
            :title="group.name"
            action-collapse
            :collapsed="true"
            class="mt-1"
            >

            <ValidationObserver :ref="`accountingForm-${index}`">
              <BForm class="my-2">
                <BRow class="align-items-center d-flex justify-content-between">
                    <div class="d-flex col col-10 ">
                      <TextInputValidated vsName="Nombre" vsMd="3" :vsModel.sync="accounting_account.name" vsRequired vsRules="required" />
                      <NumberInputValidated v-if="!accounting_account.subAccount" vsName="Código" vsMd="3" :vsModel.sync="accounting_account.code" vsRequired vsRules="required" />
                      <NumberInputValidated v-if="accounting_account.subAccount" vsName="Subcódigo" vsMd="3" :vsModel.sync="accounting_account.subcode" vsRequired vsRules="required" />
                      <VSelectValidated v-if="accounting_account.subAccount" vsMd="3" vsName="Cuenta contable asociada" :vsOptions="group.accounting_accounts" :vsModel.sync="accounting_account.accounting_account" vsLabel="name" vsRequired vsRules="required"/>
                      <CheckboxValidated class="mt-3" vsName="show_tpv" vsLabel="Subcuenta contable" :vsModel.sync="accounting_account.subAccount"></CheckboxValidated>
                    </div>
                    <BCol cols="2" class="text-right">
                      <BButton variant="primary" @click="createAccountingAccount(group.id, $refs[`accountingForm-${index}`][0])">Añadir</BButton>
                    </BCol>
                </BRow>
              </BForm>
            </ValidationObserver>

            <BCardText >
              <BTable ref="accountingAccountsTable" striped variant="secondary" :items="group.accounting_accounts" :fields="fields" show-empty empty-text="Ningún alumno matriculado"> 
                <template #cell(name)="data">
                    <BButton variant="flat-info" class="btn-icon mr-1 p-0" @click.prevent="" @click="data.toggleDetails()">
                      <FeatherIcon size="18" icon="ChevronDownIcon" />
                    </BButton>  
                    <TextInputValidated :key="accountsTable+data.item.name " v-if="data.item.modify" :vsModel.sync="data.item.name" class="p-0 m-0"></TextInputValidated>
                    <span :key="accountsTable+data.item.name +'2'" v-else> {{ data.item.name }} </span>

                </template>
                <template #cell(code)="data">
                    <NumberInputValidated  :key="accountsTable+data.item.name " v-if="data.item.modify" :vsModel.sync="data.item.code" class="p-0 m-0"></NumberInputValidated>
                    <span :key="accountsTable+data.item.code +'2'" v-else> {{ data.item.code }} </span>
                </template>

                <template #cell(actions)="data">
                    <BDropdown v-if="!data.item.modify" variant="link" no-caret :right="$store.state.appConfig.isRTL" >
                      <template #button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                      </template>
                      <BDropdownItem @click="data.item.modify=true; accountsTable++">
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">{{ $t('Edit') }}</span>
                      </BDropdownItem>
                      <BDropdownItem @click="deletePopupAxios(data.item.id, `accounting-accounts/${data.item.id}`)">
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">{{ $t('Delete') }}</span>
                      </BDropdownItem>
                    </BDropdown>
                    <div v-else class="d-flex">
                      <BButton variant="flat-success" class="btn-icon" @click="editAccountingAccount(data.item)">
                        <FeatherIcon size="18" icon="CheckIcon" />
                      </BButton>
                      <BButton variant="flat-danger" class="btn-icon" @click="data.item.modify=false; accountsTable++">
                        <FeatherIcon size="18" icon="XIcon" />
                        </BButton>
                    </div>
                  </template>

                  <template #row-details="data">
                    <BRow v-for="subaccount in data.item.accounting_subaccounts" class="mb-1">
                      <TextInputValidated :vsMd="3" :key="accountsTable+subaccount.name" v-if="subaccount.modify" :vsModel.sync="subaccount.name" class="p-0 ml-3"></TextInputValidated>
                      <BCol v-else cols="3" class="ml-3">{{subaccount.name}}</BCol>
                      <BCol cols="2">{{String(subaccount.subcode).padStart(5,'0')}}</BCol>
                      <BCol cols="2">
                        <BDropdown v-if="!subaccount.modify" variant="link" no-caret :right="$store.state.appConfig.isRTL" >
                          <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                          </template>
                          <BDropdownItem @click="subaccount.modify=true; accountsTable++">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">{{ $t('Edit') }}</span>
                          </BDropdownItem>
                          <BDropdownItem @click="deletePopupAxios(data.item.id, `accounting-accounts/${subaccount.id}`)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">{{ $t('Delete') }}</span>
                          </BDropdownItem>
                        </BDropdown>
                        <div v-else class="d-flex">
                          <BButton variant="flat-success" class="btn-icon" @click="editAccountingAccount(subaccount)">
                            <FeatherIcon size="18" icon="CheckIcon" />
                          </BButton>
                          <BButton variant="flat-danger" class="btn-icon" @click="subaccount.modify=false; accountsTable++">
                            <FeatherIcon size="18" icon="XIcon" />
                          </BButton>
                        </div>


                      </BCol>
                    </BRow>
                </template>

            </BTable>
            </BCardText>
          </BCardActions>
        </div>
    </BCard>


  </div>
</template>

<script>
  import { BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormRadioGroup, BTable, BSidebar, VBToggle, BFormFile, BInputGroup, BFormRadio, BDropdown, BDropdownItem, BCardText} from 'bootstrap-vue'
  import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
  import { inject, ref } from '@vue/composition-api'
  import { getTaxes, addTax } from '@/composables/taxService'
  import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import TextareaValidated from '@/components/forms/TextareaValidated.vue'
  import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
  import VSelectValidated from '@/components/forms/vSelectValidated.vue'
  import Ripple from 'vue-ripple-directive'
  import popups from '@/hooks/popups'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import axios from '@axios'
  import ViewData from '@/components/ViewData.vue'
  import ability from '@/libs/acl/ability'
  import { getAccountingGroups, updateAccountingAccount, addAccountingAccount } from '@/composables/accountingAccountService' 

  export default {
    components: { BRow, BCol, BCard, BFormGroup, BFormInput, BFormRadioGroup, BForm, BButton, TextInputValidated, NumberInputValidated, CheckboxValidated, VSelectValidated, BTable, BSidebar, BFormFile, ValidationProvider, ValidationObserver, BInputGroup, TextareaValidated, BFormRadio, ViewData, BDropdown, BDropdownItem, BCardActions, BCardText},
    directives: { Ripple, 'b-toogle': VBToggle },
    setup(){
      const { deletePopupAxios ,errorToast, successToast } = popups()
      const accountsTable = ref(0)
      const economicActivities = ref([])
      const accountingForm = ref(null)
      const accountingGroups=ref([])
      const accountingAccountsTable = ref(null)
      const settings = inject('settings')
      const subAccountingAccount = ref(null)
      const fields = [
        { key: 'name', label: 'Nombre' },
        { key: 'code', label: 'Código' },
        { key: 'actions', label: 'Acciones' },
        { key: 'collapsible', label: '' },
      ]

      const accounting_account = ref({
        name: null, 
        billing_document_id: null,
        identifier: null,
        is_default: false
      })

      const refetchData = () => {
        fetchAccountingGroups()
      }

      const createAccountingAccount = async function (accounting_group_id, formRef) {
        accounting_account.value.accounting_group_id = accounting_group_id
        
        if (accounting_account.value.subAccount) {
          accounting_account.value.code = accounting_account.value.accounting_account.code
          accounting_account.value.accounting_account_id = accounting_account.value.accounting_account.id
        }

        
        formRef.validate().then(async success => {
          if(success){
            console.log(accounting_account.value.code)
            if (String(accounting_account.value.code).length!=3) {
              errorToast('El código debe tener 3 dígitos')
              return
            }
    
            if (accounting_account.value.subcode && String(accounting_account.value.subcode).length>=5) {
              errorToast('El subcódigo debe tener menos de 5 dígitos')
              return
            }
            let response = await addAccountingAccount(accounting_account.value)
            if (response.data.success) {
              successToast("Cuenta contable añadida correctamente")
              fetchAccountingGroups()

              accounting_account.value = {
                name: null, 
                billing_document_id: null,
                economic_activity_id: null,
                identifier: null,
                is_default: false
              }

            } else {
              if (response.data.code == 'EXISTING_SUBCODE') {
                errorToast('Ya existe una subcuenta con este subcódigo')
              } else if (response.data.code == 'EXISTING_CODE') {
                errorToast('Ya existe una cuenta con este código')
              } else {
                errorToast("Error añadiendo cuenta contable")
              }
            }
          }
        })
      }


      const editAccountingAccount = async function (accountingAccount) {
        let response = await updateAccountingAccount(accountingAccount)
        if (response.data.success) {
          successToast("Cuenta contable actualizada correctamente.")
          fetchAccountingGroups()
        } else {
          if (response.data.code == 'EXISTING_SUBCODE') {
                errorToast('Ya existe una subcuenta con este subcódigo')
              } else if (response.data.code == 'EXISTING_CODE') {
                errorToast('Ya existe una cuenta con este código')
              } else {
                errorToast("Error actualizando cuenta contable")
              }
        }
      }

      const fetchAccountingGroups = async function () { accountingGroups.value = (await getAccountingGroups()).data }

      fetchAccountingGroups()

      return {
        settings,
        economicActivities,
        accountingGroups,
        deletePopupAxios,
        createAccountingAccount,
        accounting_account,
        ability,
        fields,
        accountingForm,
        accountingAccountsTable,
        accountsTable,
        editAccountingAccount,
        refetchData
      }
    },
  }
</script>
